import { Route, Routes } from "react-router-dom";
import TermsPage from "../Pages/TermsPage/TermsPage";
import ForgotPassword from "../Pages/Auth/ForgotPassword/ForgotPassword";
import ResetPassword from "../Pages/Auth/ResetPassword/ResetPassword";
import {
  // AUTHENTICATION
  Login,
  //
  Dashboard,
  Customers,
  SalesHistory,
  NewSale,
  CheckIn,
  CheckOut,
  // MANAGE USERS
  AddUser,
  EditUser,
  ExistingUsersPage,
  // SERVICE PAGES
  Brands,
  Category,
  Products,
  ProductsType,
  RateChart,
  // SUPPLIER PAGES
  Suppliers,
  SuppliersCategory,
  SuppliersProducts,
  StockRequisitions,
  // DAILY REPORTS
  DailyReports,
  OrderReports,
  SalesReports,
  ServiceReports,
  CustomerOrderReports,
  OrderQueueReports,
  InventoryReports,
  DailyOccupencyReports,
  // TOOLS
  FinancialYear,
  MailSettings,
  MasterSettings,
  FileTools,
  Roles,
  // TOOLS/ OUTLET
  Outlets,
  AddProduct,
  CreateBrand,
  EditProduct,
  SalesDetails,
  EditBooking,
  EditCharges,
  PrintInvoice,
  PrintStock,
  PrintQuotation,
  PrintOrdersReport,
  PrintSalesReport,
  PrintServiceReport,
  PrintCustomerOrderReport,
  PrintOrderQueueReport,
  PrintInventoryReport,
  PrintCreditNote,
  Unauthorized,
  PrintStockRequsition,
  PrintJobCard,
  AllReports,
  StockApproval,
  StockApprovalDetails,
  LandingPage,
  Reservation,
  Contact,
  ViewAccount,
  AddAccount,
  EditAccount,
  CreditReport,
  BarTender,
  BarSale,
  // StockApproval
} from "../Pages/AllPages";
import { CreditNoteList, CreditNoteDetail } from "../Components/CreditNote";
import PrivateRoute from "./PrivateRoute";
import { Toaster } from "react-hot-toast";
import MobileDashboard from "../Components/MobileDashboard/MobileDahsboard";
import CreditAccounts from "../Pages/ManageUsers/CreditAccounts/CreditAccounts";

const AllRoutes = () => {
  return (
    <>
      <Toaster position="top-center" reverseOrder={false} />
      <Routes>
        <Route
          path="*"
          element={<h1 className="text-center">Page not found</h1>}
        />
        <Route path="/unauthorized" element={<Unauthorized />} />
        <Route path="/" element={<LandingPage />} />
        <Route path="/reservation" element={<Reservation />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/terms-and-conditions" element={<TermsPage />} />
        {/* requiredPermissionID={101} */}
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/mobile-dashboard"
          element={
            <PrivateRoute>
              <MobileDashboard />
            </PrivateRoute>
          }
        />

        <Route path="/stock-approval">
          <Route
            path=""
            element={
              <PrivateRoute requiredPermissionID={2004}>
                <StockApproval />
              </PrivateRoute>
            }
          />
          <Route
            path="details"
            element={
              <PrivateRoute requiredPermissionID={2004}>
                <StockApprovalDetails />
              </PrivateRoute>
            }
          />
        </Route>
        <Route
          path="/new-sale"
          element={
            <PrivateRoute requiredPermissionID={1}>
              <NewSale />
            </PrivateRoute>
          }
        />
        <Route path="/sales-history">
          <Route
            path=""
            element={
              <PrivateRoute requiredPermissionID={2}>
                <SalesHistory />
              </PrivateRoute>
            }
          />
          <Route
            path="check-in"
            element={
              <PrivateRoute requiredPermissionID={2}>
                <CheckIn />
              </PrivateRoute>
            }
          />
          <Route
            path="check-out"
            element={
              <PrivateRoute requiredPermissionID={2}>
                <CheckOut />
              </PrivateRoute>
            }
          />
          <Route
            path="details"
            element={
              <PrivateRoute requiredPermissionID={2}>
                <SalesDetails />
              </PrivateRoute>
            }
          />
          <Route
            path="edit"
            element={
              <PrivateRoute requiredPermissionID={3}>
                <EditBooking />
              </PrivateRoute>
            }
          />
          <Route
            path="editCharges"
            element={
              <PrivateRoute requiredPermissionID={3}>
                <EditCharges />
              </PrivateRoute>
            }
          />

          <Route
            path="print-invoice"
            element={
              <PrivateRoute requiredPermissionID={2}>
                <PrintInvoice />
              </PrivateRoute>
            }
          />
          <Route
            path="print-stock"
            element={
              <PrivateRoute requiredPermissionID={2}>
                <PrintStock />
              </PrivateRoute>
            }
          />
          <Route
            path="print-quotation"
            element={
              <PrivateRoute requiredPermissionID={2}>
                <PrintQuotation />
              </PrivateRoute>
            }
          />
          <Route
            path="print-jobcard"
            element={
              <PrivateRoute requiredPermissionID={2}>
                <PrintJobCard />
              </PrivateRoute>
            }
          />
          <Route
            path="print-credit-note"
            element={
              <PrivateRoute requiredPermissionID={2}>
                <PrintCreditNote />
              </PrivateRoute>
            }
          />
        </Route>

        <Route
          path="/customers"
          element={
            <PrivateRoute requiredPermissionID={19}>
              <Customers />
            </PrivateRoute>
          }
        />

        <Route path="/manage-users">
          <Route
            path="add-user"
            element={
              <PrivateRoute requiredPermissionID={44}>
                <AddUser />
              </PrivateRoute>
            }
          />
          <Route
            path="edit-user"
            element={
              <PrivateRoute requiredPermissionID={44}>
                <EditUser />
              </PrivateRoute>
            }
          />
          <Route
            path="existing-users"
            element={
              <PrivateRoute requiredPermissionID={44}>
                <ExistingUsersPage />
              </PrivateRoute>
            }
          />
          <Route
            path="pending-credit-accounts"
            element={
              <PrivateRoute requiredPermissionID={44}>
                <CreditAccounts />
              </PrivateRoute>
            }
          />
        </Route>

        <Route path="/service">
          {/* {requiredPermissionID={21} */}
          <Route
            path="category"
            element={
              <PrivateRoute requiredPermissionID={21}>
                <Category />
              </PrivateRoute>
            }
          />
          <Route
            path="brands"
            element={
              <PrivateRoute requiredPermissionID={22}>
                <Brands />
              </PrivateRoute>
            }
          />
          <Route
            path="brand/create"
            element={
              <PrivateRoute requiredPermissionID={22}>
                <CreateBrand />
              </PrivateRoute>
            }
          />
          <Route
            path="products"
            element={
              <PrivateRoute requiredPermissionID={24}>
                <Products />
              </PrivateRoute>
            }
          />
          <Route
            path="product/add-product"
            element={
              <PrivateRoute requiredPermissionID={23}>
                <AddProduct />
              </PrivateRoute>
            }
          />
          <Route
            path="product/edit"
            element={
              <PrivateRoute requiredPermissionID={24}>
                <EditProduct />
              </PrivateRoute>
            }
          />
          <Route
            path="products-type"
            element={
              <PrivateRoute requiredPermissionID={23}>
                <ProductsType />
              </PrivateRoute>
            }
          />
          <Route
            path="rate-chart"
            element={
              <PrivateRoute requiredPermissionID={25}>
                <RateChart />
              </PrivateRoute>
            }
          />
        </Route>

        <Route path="/supplier">
          <Route
            path=""
            element={
              <PrivateRoute requiredPermissionID={26}>
                <Suppliers />
              </PrivateRoute>
            }
          />
          <Route
            path="category"
            element={
              <PrivateRoute requiredPermissionID={28}>
                <SuppliersCategory />
              </PrivateRoute>
            }
          />
          <Route
            path="products"
            element={
              <PrivateRoute requiredPermissionID={29}>
                <SuppliersProducts />
              </PrivateRoute>
            }
          />
          <Route
            path="stock-requisitions"
            element={
              <PrivateRoute requiredPermissionID={30}>
                <StockRequisitions />
              </PrivateRoute>
            }
          />
          <Route
            path="stock-requisitions/print"
            element={
              <PrivateRoute requiredPermissionID={30}>
                <PrintStockRequsition />
              </PrivateRoute>
            }
          />
        </Route>

        <Route path="/reports">
          {/* <Route path="daily-reports" element={<PrivateRoute requiredPermissionID={31}><DailyReports /></PrivateRoute>} /> */}
          <Route
            path="order-reports"
            element={
              <PrivateRoute requiredPermissionID={32}>
                <OrderReports />
              </PrivateRoute>
            }
          />
          <Route
            path="order-reports/print"
            element={
              <PrivateRoute requiredPermissionID={32}>
                <PrintOrdersReport />
              </PrivateRoute>
            }
          />

          <Route
            path="sales-reports"
            element={
              <PrivateRoute requiredPermissionID={33}>
                <SalesReports />
              </PrivateRoute>
            }
          />
          <Route
            path="sales-reports/print"
            element={
              <PrivateRoute requiredPermissionID={33}>
                <PrintSalesReport />
              </PrivateRoute>
            }
          />

          {/* <Route path="service-reports" element={<PrivateRoute requiredPermissionID={35}><ServiceReports /></PrivateRoute>} />
                <Route path="service-reports/print" element={<PrivateRoute requiredPermissionID={35}><PrintServiceReport /></PrivateRoute>} /> */}

          <Route
            path="customer-order-report"
            element={
              <PrivateRoute requiredPermissionID={36}>
                <CustomerOrderReports />
              </PrivateRoute>
            }
          />
          <Route
            path="customer-order-report/print"
            element={
              <PrivateRoute requiredPermissionID={36}>
                <PrintCustomerOrderReport />
              </PrivateRoute>
            }
          />

          {/* <Route path="order-queue-report" element={<PrivateRoute><OrderQueueReports /></PrivateRoute>} />
                <Route path="order-queue-report/print" element={<PrivateRoute><PrintOrderQueueReport /></PrivateRoute>} /> */}

          <Route
            path="inventory-report"
            element={
              <PrivateRoute requiredPermissionID={38}>
                <InventoryReports />
              </PrivateRoute>
            }
          />
          <Route
            path="inventory-report/print"
            element={
              <PrivateRoute requiredPermissionID={38}>
                <PrintInventoryReport />
              </PrivateRoute>
            }
          />

          <Route
            path="daily-occupancy-reports"
            element={
              <PrivateRoute requiredPermissionID={39}>
                <DailyOccupencyReports />
              </PrivateRoute>
            }
          />
          <Route
            path="all-reports"
            element={
              <PrivateRoute>
                <AllReports />
              </PrivateRoute>
            }
          />
        </Route>

        <Route path="/tools">
          <Route
            path="financial-year"
            element={
              <PrivateRoute requiredPermissionID={40}>
                <FinancialYear />
              </PrivateRoute>
            }
          />
          <Route
            path="mail-settings"
            element={
              <PrivateRoute requiredPermissionID={41}>
                <MailSettings />
              </PrivateRoute>
            }
          />
          <Route
            path="master-settings"
            element={
              <PrivateRoute requiredPermissionID={42}>
                <MasterSettings />
              </PrivateRoute>
            }
          />
          <Route
            path="file-tools"
            element={
              <PrivateRoute requiredPermissionID={43}>
                <FileTools />
              </PrivateRoute>
            }
          />
          <Route
            path="outlets"
            element={
              <PrivateRoute requiredPermissionID={45}>
                <Outlets />
              </PrivateRoute>
            }
          />
          <Route path="roles">
            <Route
              path=""
              element={
                <PrivateRoute>
                  <Roles />
                </PrivateRoute>
              }
            />
          </Route>
          {/* <Route path="roles">
                  <Route path="" element={<PrivateRoute requiredPermissionID={47}><Roles /></PrivateRoute>}/>
                </Route> */}
        </Route>
        <Route path="/credit">
          <Route
            path="view-account"
            element={
              <PrivateRoute requiredPermissionID={3002}>
                <ViewAccount />
              </PrivateRoute>
            }
          />
          <Route
            path="add-account"
            element={
              <PrivateRoute requiredPermissionID={3003}>
                <AddAccount />
              </PrivateRoute>
            }
          />
          {/* <Route path='edit-account' element={<PrivateRoute requiredPermissionID={3004}><EditAccount/></PrivateRoute>} /> */}
          <Route
            path="credit-note"
            element={
              <PrivateRoute requiredPermissionID={3008}>
                <CreditNoteList />
              </PrivateRoute>
            }
          />
          <Route
            path="credit-note/:orderId"
            element={
              <PrivateRoute requiredPermissionID={3008}>
                <CreditNoteDetail />
              </PrivateRoute>
            }
          />
          <Route
            path="credit-report"
            element={
              <PrivateRoute requiredPermissionID={3005}>
                <CreditReport />
              </PrivateRoute>
            }
          />
        </Route>
        <Route path="/beverage-sales">
          <Route
            path="bar-sale"
            element={
              <PrivateRoute requiredPermissionID={3006}>
                <BarSale />
              </PrivateRoute>
            }
          />
        </Route>
      </Routes>
    </>
  );
};

export default AllRoutes;
